export const hasDiscount = (price, oldPrice) =>
  oldPrice != null && Number(oldPrice) > Number(price);

export const normalizeWholesaleTiers = (tiers) => {
  if (!Array.isArray(tiers)) return [];
  return tiers
    .map((tier) => ({
      minQty: Number(tier?.minQty ?? tier?.min_qty),
      price: Number(tier?.price),
    }))
    .filter((tier) => tier.minQty >= 2 && tier.price > 0)
    .sort((a, b) => a.minQty - b.minQty);
};

export const resolveWholesaleTiers = (product) => {
  const fromJson = normalizeWholesaleTiers(product?.wholesalePrices);
  if (fromJson.length) return fromJson;

  const legacyQty = Number(product?.wholesaleMinQty);
  const legacyPrice = Number(product?.wholesalePrice);
  if (legacyQty >= 2 && legacyPrice > 0) {
    return [{ minQty: legacyQty, price: legacyPrice }];
  }

  return [];
};

export const hasWholesaleTiers = (productOrTiers) => {
  if (Array.isArray(productOrTiers)) {
    return normalizeWholesaleTiers(productOrTiers).length > 0;
  }
  return resolveWholesaleTiers(productOrTiers).length > 0;
};

/** @deprecated use hasWholesaleTiers */
export const hasWholesale = (wholesalePrice, wholesaleMinQty) =>
  Number(wholesalePrice) > 0 && Number(wholesaleMinQty) >= 2;

export const validateWholesaleTiers = (tiers, retailPrice) => {
  const normalized = normalizeWholesaleTiers(
    tiers.filter((tier) => tier.minQty !== '' || tier.price !== '')
  );
  const priceNum = Number(retailPrice);

  if (!priceNum) return 'Вкажіть роздрібну ціну';

  const qtySet = new Set();
  for (const tier of normalized) {
    if (tier.minQty < 2) {
      return 'Мінімальна кількість для опту — від 2 шт.';
    }
    if (tier.price >= priceNum) {
      return 'Оптова ціна повинна бути нижчою за роздрібну';
    }
    if (qtySet.has(tier.minQty)) {
      return 'Кількість в оптових рівнях не повинна повторюватися';
    }
    qtySet.add(tier.minQty);
  }

  if (normalized.length > 10) {
    return 'Максимум 10 оптових рівнів';
  }

  return null;
};

export const getWholesalePriceForQty = (productOrTiers, qty, retailPrice) => {
  const tiers = Array.isArray(productOrTiers)
    ? normalizeWholesaleTiers(productOrTiers)
    : resolveWholesaleTiers(productOrTiers);

  let result = Number(retailPrice);
  for (const tier of tiers) {
    if (Number(qty) >= tier.minQty) {
      result = tier.price;
    }
  }
  return result;
};

/** Цена за единицу с учётом опта при заданном количестве. */
export const getUnitPriceForQuantity = (product, quantity) =>
  getWholesalePriceForQty(product, quantity, product?.price);

export const isWholesalePriceApplied = (product, quantity) => {
  const retail = Number(product?.price);
  const unit = getUnitPriceForQuantity(product, quantity);
  return retail > 0 && unit < retail;
};

export const getFirstWholesaleTier = (product) => {
  const tiers = resolveWholesaleTiers(product);
  return tiers[0] ?? null;
};

export const getBestWholesaleTier = (product) => {
  const tiers = resolveWholesaleTiers(product);
  if (!tiers.length) return null;
  return tiers.reduce((best, tier) => (tier.price < best.price ? tier : best), tiers[0]);
};

export const getWholesaleDiscountPercent = (retailPrice, wholesalePrice) => {
  const retail = Number(retailPrice);
  const wholesale = Number(wholesalePrice);
  if (!retail || !wholesale || wholesale >= retail) return null;
  return ((1 - wholesale / retail) * 100).toFixed(2);
};
